import React from 'react';
import {Grid, Typography} from '@material-ui/core';


import {makeStyles} from '@material-ui/core/styles';
import Path4 from '../Paths/path4';
import emailjs from 'emailjs-com';

const useStyles= makeStyles((themes)=>({

    gmail: {
        backgroundColor:"rgb(235, 235, 235)",
        textAlign:"center",
        borderRadius:"10px",
        boxShadow:"10px 10px 5px rgb(235, 235, 235)",
        height:"500px",
        marginBottom:"20px"
    },
    path4:{
        backgroundColor:"white",
        textAlign:"center",
        paddingLeft:"7.5%",
        paddingRight:"7.5%",
        
    },
    contact:{
        margin:'auto',
        fontSize:"30px",
        paddingTop:"30px",
        paddingBottom:'30px',
    },
    inputs:{
        backgroundColor:"white",
        width:"40%",
        height:"30px",
        borderTopStyle:"hidden",
        borderBottomStyle:"hidden",
        borderRightStyle:"hidden",
        borderLeftStyle:"hidden",
        marginBottom:"30px",
        borderRadius:"5px",
        textColor:"black",
        paddingLeft:"10px",

        [themes.breakpoints.down('xs')]: {
            width:"70%"
          },

        '&:hover':{
            backgroundColor:'white',
            outline:'none'
        }
    },
    inputs2:{
        backgroundColor:"white",
        width:"40%",
        height:"120px",
        borderTopStyle:"hidden",
        borderBottomStyle:"hidden",
        borderRightStyle:"hidden",
        borderLeftStyle:"hidden",
        marginBottom:"30px",
        borderRadius:"5px",
        textColor:"black",
        paddingLeft:"10px",

        [themes.breakpoints.down('xs')]: {
            width:"70%"
          },

        '&:hover':{
            backgroundColor:'white',
            outline:'none'
        }
    },
    button:{
        width:"150px",
        height:"40px",
        backgroundColor:'rgb(58, 110, 165)',
        color:'white',
        borderRadius:"10px",
        borderColor:"rgb(235, 235, 235)",

        '&:hover':{
            backgroundColor:'rgb(58, 110, 165)',
            borderTopStyle:"hidden",
            borderBottomStyle:"hidden",
            borderRightStyle:"hidden",
            borderLeftStyle:"hidden",
        }
    }

}))

export default function Gmail(){

    function sendEmail(e){
        e.preventDefault();

        emailjs.sendForm('service_845xefj', 'template_1o4mgy7', e.target, 'user_jGb7IAejcCjogMNSCqXNG')
          .then((result) => {
              console.log(result.text);
              alert("Success !")
          }, (error) => {
              console.log(error.text);
              alert('oops ! something went wrong ')
          });
          e.target.reset()
    }


    const classes= useStyles();
    return(

        <div id="gmail">
            <Grid container>

                <Grid item xs={12} md={12} className={classes.path4}>
                    <Path4></Path4>
                </Grid>
                <Grid item md={1}></Grid>
                
                <Grid item xs={12} md={10} className={classes.gmail}>

                    <Typography className={classes.contact}>Contact</Typography>

                    <form onSubmit={sendEmail}>

                        <input type='text' placeholder='Name' name="name" className={classes.inputs} required/> <br></br>
                        <input type='email' placeholder='Gmail' name='email' className={classes.inputs} required/><br></br>
                        <input type='text' placeholder="Subject" name='subject' className={classes.inputs} required/><br></br>
                        <textarea placeholder="message" name="message"  className={classes.inputs2} required></textarea><br></br>
                        <input type='submit' value='Send Message' className={classes.button}></input>

                    </form>



                </Grid>

                
                <Grid item md={1}></Grid>

            </Grid>
        </div>
    );
}